import React from 'react';

function ExtraCookieAcceptanceBanner() {
	return (
		<div>
			<ol className="breadcrumb">
							<li className="breadcrumb-item"><a href="#/">Home</a></li>
							<li className="breadcrumb-item"><a href="#/">Pages</a></li>
							<li className="breadcrumb-item active"></li>
						</ol>
						
						
						<h1 className="page-header">Cookie Acceptance Banner <small>page header description goes here...</small></h1>
						
						
						
						<div className="card card-borderless">
							<div className="card-header bg-gray-900">
								<h4 className="card-header-title text-white">Card title</h4>
								<div className="card-header-btn">
									<a href="#/" className="btn btn-xs btn-icon btn-default" data-toggle="card-expand"><i className="fa fa-expand"></i></a>
									<a href="#/" className="btn btn-xs btn-icon btn-success" data-toggle="card-reload"><i className="fa fa-redo"></i></a>
									<a href="#/" className="btn btn-xs btn-icon btn-warning" data-toggle="card-collapse"><i className="fa fa-minus"></i></a>
									<a href="#/" className="btn btn-xs btn-icon btn-danger" data-toggle="card-remove"><i className="fa fa-times"></i></a>
								</div>
							</div>
							<div className="card-body">
								Card content here
							</div>
						</div>
						
						
						<div data-bs-theme="dark" className="alert alert-dismissible fade show bg-gray-900 bg-opacity-90 bg-blur-3 text-body position-fixed rounded-lg-5 shadow rounded-0 d-lg-flex align-items-center py-lg-4 px-lg-5 p-3 start-0 end-0 bottom-0 m-0 m-lg-4" style={{ zIndex: '1020' }}>
							<div className="display-3 me-lg-4 d-flex align-items-center">
								<iconify-icon icon="solar:donut-bitten-bold-duotone" className="fa-lg my-3 my-lg-0"></iconify-icon>
							</div>
							<div className="flex-fill mb-lg-0 mb-3">
								<h3 className="mb-2">This website uses cookies</h3>
								<p className="mb-3">
									We use cookies to enhance your browsing experience, analyze site traffic, and personalize content.
									By clicking "Accept", you agree to the use of cookies in accordance with our Privacy Policy.
								</p>
								<p className="m-0 d-flex gap-3">
									<a href="#/" className="link-gray-500 fw-semibold">Learn More</a>
									<a href="#/" className="link-gray-500 fw-semibold">Manage Preferences</a>
								</p>
							</div>
							<div className="ps-lg-4 pt-lg-0 d-flex flex-lg-column gap-3">
								<a href="#/" className="btn btn-light btn-lg w-200px py-10px rounded-3" data-bs-dismiss="alert">Accept</a>
								<a href="#/" className="btn btn-dark btn-lg w-200px py-10px rounded-3" data-bs-dismiss="alert">Decline</a>
							</div>
						</div>
		</div>
	);
}

export default ExtraCookieAcceptanceBanner;
